import { render, staticRenderFns } from "./AssignmentBreadcrumbs.vue?vue&type=template&id=1ccb142b&scoped=true&"
import script from "./AssignmentBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./AssignmentBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentBreadcrumbs.vue?vue&type=style&index=0&id=1ccb142b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb142b",
  null
  
)

export default component.exports